export function formatAddressSuggestionText(prediction: google.maps.places.PlacePrediction): string {
	return prediction.text?.text ?? [prediction.mainText?.text, prediction.secondaryText?.text].filter(Boolean).join(', ') ?? '';
}
